import { IAuthContext } from 'react-oauth2-code-pkce'

type AuthenticationContext = {
  accessToken: string
  organizationId: string
  userEntityId: string
}

const isExpired = (expiresAtSeconds?: number, clockSkewMillis: number = 5_000): boolean =>
  expiresAtSeconds !== undefined ? expiresAtSeconds * 1000 <= Date.now() - clockSkewMillis : false

export const isAuthContextFresh = (context?: IAuthContext): boolean => {
  const organizationId = context?.idTokenData?.organization_id ?? context?.idTokenData?.organizationId
  const userEntityId = context?.idTokenData?.user_entity_id ?? context?.idTokenData?.userEntityId
  if (!organizationId || !userEntityId) return false

  const accessTokenExpiry = context?.tokenData?.exp
  const idTokenExpiry = context?.idTokenData?.exp

  // If expiry information is missing, assume the token is usable and let the backend decide.
  const accessTokenFresh = accessTokenExpiry === undefined || !isExpired(accessTokenExpiry)
  const idTokenFresh = idTokenExpiry === undefined || !isExpired(idTokenExpiry)

  return accessTokenFresh && idTokenFresh
}

export const createAuthContext = (context?: IAuthContext): AuthenticationContext | undefined => {
  const organizationId = context?.idTokenData?.organization_id ?? context?.idTokenData?.organizationId
  const userEntityId = context?.idTokenData?.user_entity_id ?? context?.idTokenData?.userEntityId

  return isAuthContextFresh(context) && organizationId && userEntityId
    ? {
        accessToken: context!!.token,
        organizationId,
        userEntityId,
      }
    : undefined
}

export default AuthenticationContext
